<div class="flex h-full flex-col md:flex-row">
  <div
    class="bg-bg-solid-brand relative aspect-square w-full overflow-hidden md:h-full md:w-auto md:flex-1"
    [ngClass]="{ 'hidden md:block': isHeroHiddenOnMobile }">
    <img
      src="/assets/images/background-wave-brand.png"
      alt=""
      class="h-full w-full object-cover" />
    <div class="absolute inset-0 flex flex-col items-center justify-center">
      <div class="hidden space-y-8 p-16 md:block">
        <div class="flex items-center gap-3">
          <ic-abang-express class="h-9.5 w-9.5 text-white" />
          <p class="font-montserrat text-xl font-medium text-white">
            Abang <strong class="font-semibold">Express Group</strong>
          </p>
        </div>
        <div class="space-y-6">
          <p class="text-4xl leading-tight font-bold text-white">
            Setiap peran memiliki arti. <br />
            Setiap kontribusi membawa perubahan.
          </p>
          <p class="text-xl font-medium text-white">
            Bersama kita belajar, bekerja & bertumbuh untuk membangun Abang Express yang lebih baik.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    class="bg-bg-surface-default z-10 -mt-4 flex-1 rounded-t-2xl"
    [ngClass]="{ 'mt-0': isHeroHiddenOnMobile }">
    <ng-content />
  </div>
</div>
